<template>
  <div class="not-found-page">
    <div class="wscn-http404">
      <div class="pic-404">
        <img class="pic-404__parent" :src="img_404" alt="404">
        <img class="pic-404__child left" :src="img_404_cloud" alt="404">
        <img class="pic-404__child mid" :src="img_404_cloud" alt="404">
        <img class="pic-404__child right" :src="img_404_cloud" alt="404">
      </div>
      <div class="bullshit">
        <div class="bullshit__oops">{{$t('notFound.oops')}}</div>
        <!-- <div class="bullshit__info">版权所有
          <a class='link-type' href='http://www.asthmanager.com/' target='_blank'>朔茂科技</a>
        </div> -->
        <div class="bullshit__headline">{{ message }}</div>
        <div class="bullshit__info">{{$t('notFound.notFoundMsg')}}</div>
        <router-link to="/invoice" class="bullshit__return-home">{{$t('notFound.takeMeHome')}}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import img_404 from '@/static/404.png'
import img_404_cloud from '@/static/404_cloud.png'
export default {
  data(){
    return {
      img_404,
      img_404_cloud
    }
  },
  computed: {
    message() {
      return ''
    }
  }
}
</script>

<style scoped>
.not-found-page {
  min-height: 100vh;
  background: #f0f2f5;
}

.wscn-http404{
  position: relative;
  display: flex;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 100px;
  box-sizing: border-box;
  overflow: hidden;
}
.wscn-http404 .pic-404{
  position: relative;
  flex: 0 1 600px;
  width: 600px;
  padding: 150px 0;
  overflow: hidden;
}
.wscn-http404 .pic-404__parent{
  width: 100%;
}
.wscn-http404 .pic-404__child{
  position: absolute;
}
.wscn-http404 .pic-404__child.left{
  width: 80px;
  top: 17px;
  left: 220px;
  opacity: 0;
  animation-name: cloudLeft;
  animation-duration: 2s;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
  animation-delay: 1s;
}
.wscn-http404 .pic-404__child.mid{
  width: 46px;
  top: 10px;
  left: 420px;
  opacity: 0;
  animation-name: cloudMid;
  animation-duration: 2s;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
  animation-delay: 1.2s;
}
.wscn-http404 .pic-404__child.right{
  width: 62px;
  top: 100px;
  left: 500px;
  opacity: 0;
  animation-name: cloudRight;
  animation-duration: 2s;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
  animation-delay: 1s;
}
@keyframes cloudLeft {
  0% {
    top: 17px;
    left: 220px;
    opacity: 0;
  }
  20% {
    top: 33px;
    left: 188px;
    opacity: 1;
  }
  80% {
    top: 81px;
    left: 92px;
    opacity: 1;
  }
  100% {
    top: 97px;
    left: 60px;
    opacity: 0;
  }
}
@keyframes cloudMid {
  0% {
    top: 10px;
    left: 420px;
    opacity: 0;
  }
  20% {
    top: 40px;
    left: 360px;
    opacity: 1;
  }
  70% {
    top: 130px;
    left: 180px;
    opacity: 1;
  }
  100% {
    top: 160px;
    left: 120px;
    opacity: 0;
  }
}
@keyframes cloudRight {
  0% {
    top: 100px;
    left: 500px;
    opacity: 0;
  }
  20% {
    top: 120px;
    left: 460px;
    opacity: 1;
  }
  80% {
    top: 180px;
    left: 340px;
    opacity: 1;
  }
  100% {
    top: 200px;
    left: 300px;
    opacity: 0;
  }
}
.wscn-http404 .bullshit{
  position: relative;
  flex: 0 0 300px;
  width: 300px;
  padding: 150px 0;
  overflow: hidden;
}
.wscn-http404 .bullshit__oops{
  font-size: 32px;
  font-weight: bold;
  line-height: 40px;
  color: #1482f0;
  opacity: 0;
  margin-bottom: 20px;
  animation-name: slideUp;
  animation-duration: 0.5s;
  animation-fill-mode: forwards;
}
.wscn-http404 .bullshit__headline{
  font-size: 20px;
  line-height: 24px;
  color: #1482f0;
  opacity: 0;
  margin-bottom: 10px;
  animation-name: slideUp;
  animation-duration: 0.5s;
  animation-delay: 0.1s;
  animation-fill-mode: forwards;
}
.wscn-http404 .bullshit__info{
  font-size: 13px;
  line-height: 21px;
  color: grey;
  opacity: 0;
  margin-bottom: 30px;
  animation-name: slideUp;
  animation-duration: 0.5s;
  animation-delay: 0.2s;
  animation-fill-mode: forwards;
}
.wscn-http404 .bullshit__return-home{
  display: block;
  width: 110px;
  height: 36px;
  background: #1482f0;
  border-radius: 100px;
  text-align: center;
  color: #ffffff;
  opacity: 0;
  font-size: var(--responsive-font-14);
  line-height: 36px;
  cursor: pointer;
  animation-name: slideUp;
  animation-duration: 0.5s;
  animation-delay: 0.3s;
  animation-fill-mode: forwards;
  text-decoration : none
}

@media (max-width: 900px) {
  .wscn-http404 {
    display: block;
    padding: 32px 24px;
  }

  .wscn-http404 .pic-404 {
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
    padding: 32px 0;
  }

  .wscn-http404 .pic-404__child {
    display: none;
  }

  .wscn-http404 .bullshit {
    width: 100%;
    padding: 20px 0 40px;
    text-align: center;
  }

  .wscn-http404 .bullshit__return-home {
    margin: 0 auto;
  }
}
@keyframes slideUp {
  0% {
    transform: translateY(60px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
